import React, {useMemo} from 'react'

import FieldFormElement from "../../../../../../../../../core/fields3/render/form-elemnent"
import ButtonSubmit from "../../../../../../../../../core/gd-form/common/btn-submit/btn-submit-ui5-new"
import FormModel from "../../../../../../../../../core/gd-form/common/form-model-manager"
import FormFieldError from "../../../../../../../../../core/gd-form/common/form-error/form-field-error"
import AddViewRowTitle from "../row-title/row-title"
import ProjectView_Embed from "../../../../../../../../../core/model2/project-view/views/embed/embed-view"
import {EmbedTypeConfig, EmbedTypeConfigs} from "../../../../../../../../../core/gd/const/embed/embed-type-config"
import {ViewType} from "../../../../../../../../../core/gd/const/views/view-type"
import {
    projectViews_createProjectViewFromConfig
} from "../../../../../../../../../core/model2/project-view/actions/create"
import {ProjectViewAccess} from "../../../../../../../../../core/model2/project-view/@const"
import {AddView_OptionConfig} from "../../../../../../../../../core/gd-ui/add-view/@types";
import AddView_SelectView from "./select-view"
import AddView_ViewHeader from "./view-header"

type Props = {
    config          : AddView_OptionConfig

    hidePopover     : func
    onBack          : func
}

const debug = false
// const debug = "AddViewPreviewEmbedForm"

export default function AddViewPreviewEmbedForm(props: Props) {

    debug && console.log(debug, 'render')

    const onSubmit = async (model: ProjectView_Embed) => {
        debug && console.log(debug, 'onSubmit', model, view)

        const params: any = {
            name        : model.name,
            access      : model.access,
        }

        model.embedCode = model.embedCode?.trim()

        debug && console.log(debug, 'onSubmit params', params, view)

        if (view.acl.canDuplicate) {
            gd.projectViews.duplicate(view, params)
        }

        props.hidePopover()
    }

    const view = useMemo(()=>{
        const res = projectViews_createProjectViewFromConfig(gd.projectViews, {
            systemType: ViewType.PROJECT_EMBED
        }) as ProjectView_Embed

        const embedTypeConfig: EmbedTypeConfig = EmbedTypeConfigs[props.config.formParams.embedType as keyof {}]
        res.name                = embedTypeConfig?.name || ''
        res.embedCode           = embedTypeConfig?.embedCode || ''
        res.access              = ProjectViewAccess.PUBLIC
        res.defaultEmbedType    = props.config.formParams.embedType
        return res
    }, [])

    const form   = useMemo(()=>new FormModel(view, {
        onSubmit        : onSubmit,
        isFormChanged   : true,
    }), [view])

    const embedTypeConfig = EmbedTypeConfigs[props.config.formParams.embedType as keyof {}] as EmbedTypeConfig
    const {iconSvg, description} = embedTypeConfig


    const embedCodeLabel        : any = embedTypeConfig.embedCodeLabel || 'Paste URL or Embed code'
    const embedCodeDescription  : any = embedTypeConfig.helpContent

    debug && console.log(debug, 'render', view)

    const viewConfig = {
        iconSvg     : iconSvg,
        name        : view.name,
        description : description
    }

    return (
        <div className="flex-column-left-top h-100-percent p-l-10 p-r-10">
            <AddView_SelectView onBack={props.onBack}/>
            <AddView_ViewHeader viewConfig={viewConfig}/>

            {view.acl.canCreateNew &&
                <div className="flex-column-left-top w-100-percent m-t-30">
                    <div className="flex-column-left-top w-100-percent">
                        <AddViewRowTitle field={gd.fields.projectView.name}/>
                        <FieldFormElement className = "w-100-percent"
                                          field     = {gd.fields.projectView.name}
                                          form      = {form}/>
                        <FormFieldError form    = {form}
                                        field   = {gd.fields.projectView.name}/>
                    </div>

                    <div className="flex-column-left-top w-100-percent m-t-15">
                        <AddViewRowTitle field={gd.fields.projectView.access}/>
                        <FieldFormElement className = "w-100-percent"
                                          field     = {gd.fields.projectView.access}
                                          form      = {form}
                                          options   = {{showIcon: true}}/>
                    </div>

                    <div className="flex-column-left-top w-100-percent m-t-15">

                        <AddViewRowTitle field          = {gd.fields.projectView.embedCode}
                                         title          = {embedCodeLabel}
                                         description    = {embedCodeDescription}/>

                        <FieldFormElement className = "w-100-percent"
                                          field     = {gd.fields.projectView.embedCode}
                                          rows      = {2}
                                          form      = {form}/>
                        <FormFieldError className   = "w-100-percent"
                                        form        = {form}
                                        field       = {gd.fields.projectView.embedCode}/>
                    </div>
                </div>}

            <div className="h-100-percent"/>

            <div className="flex-row-center-center w-100-percent p-t-15 p-b-30">
                <ButtonSubmit size="36" form={form} label="Add view"/>
            </div>
        </div>
    )
}
